export const state = {
  funcionario: {},
  funcionarios: [],
  dependente: {
    nome: "",
    data_nascimento: ""
  },
  salario: {
    mes: "",
    ano: "",
    valor: ""
  },
  dependentes: [],
  salarios: [],
  modalExcluirFuncionario: false,
  modalCadastrarFuncionario: false,
  modalPermissaoFuncionario: false,
  permissaoFuncionario: {
    permissao: "",
    permitido: false,
    metodo: "",
  },
};

export default {};
